import { render, staticRenderFns } from "./NewProductAccessorySummary.vue?vue&type=template&id=6e6b02dd"
import script from "./NewProductAccessorySummary.vue?vue&type=script&lang=js"
export * from "./NewProductAccessorySummary.vue?vue&type=script&lang=js"
import style0 from "./NewProductAccessorySummary.vue?vue&type=style&index=0&id=6e6b02dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports